import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';

const TermsOfServiceModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Terms of Service</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <div className="space-y-4 text-sm">
            <div>
              <p className="font-semibold text-gray-900">L.H. Cinq-continent Inc.</p>
              <p className="text-gray-600">NEQ: 2264343056</p>
              <p className="text-gray-600">Effective Date: March 28, 2026</p>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">Terms of WiFi & Service Usage</h3>
              <p className="text-gray-700 mb-4">
                By connecting to our Wi-Fi network or using Homesbyli services, you agree to the following terms:
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">1. Privacy & Data Usage</h3>
              <p className="text-gray-700">
                In compliance with Canadian privacy laws (PIPEDA & Quebec's Law 25), your data is used solely for identity verification and to enhance your stay. We <strong>do not sell your data</strong> to third parties.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">2. Network Access & Security</h3>
              <p className="text-gray-700">
                By connecting to our network, you agree to:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-gray-700 mt-2">
                <li>Use the network for lawful purposes only</li>
                <li>Not engage in any activity that may harm or disrupt the network</li>
                <li>Not attempt to access unauthorized systems or data</li>
                <li>Respect bandwidth limits and fair usage policies</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">3. Personal Information</h3>
              <p className="text-gray-700">
                We collect your Name, Email, and Phone Number to:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-gray-700 mt-2">
                <li>Grant secure network access</li>
                <li>Verify identity for building security and insurance purposes</li>
                <li>Provide exclusive partner discounts and offers</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">4. Service Availability</h3>
              <p className="text-gray-700">
                While we strive to provide continuous WiFi service, we do not guarantee uninterrupted access. Service may be temporarily unavailable due to maintenance, technical issues, or circumstances beyond our control.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">5. Limitation of Liability</h3>
              <p className="text-gray-700">
                Homesbyli (L.H. Cinq-continent Inc.) is not responsible for any data loss, security breaches, or damages resulting from your use of the WiFi network.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">6. Modifications</h3>
              <p className="text-gray-700">
                We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of any changes.
              </p>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-6">
              <p className="text-sm text-blue-900">
                <strong>Questions or Concerns?</strong><br />
                Contact us at: <a href="mailto:info@send.homesbyli.com" className="text-blue-600 hover:underline">info@send.homesbyli.com</a>
              </p>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default TermsOfServiceModal;
